// import {TempusDominus} from "@eonasdan/tempus-dominus";
require('jquery');
// require('../../node_modules/moment/moment');
require('./bootstrap');
require('../../node_modules/tether/dist/js/tether');
require('masonry-layout/dist/masonry.pkgd.min');
require('../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
// require('../../node_modules/@eonasdan/tempus-dominus/dist/js/tempus-dominus');
// import {tempusDominus} from '../../node_modules/@eonasdan/tempus-dominus/dist/js/tempus-dominus';
require('../../node_modules/tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4.min');
require('../../node_modules/bootstrap-select/dist/js/bootstrap-select.min');
require('./sweetalert');  // Include the SweetAlert logic
let $dateTimePicker = $('#start_date');
let $birthDatePicker = $('#birth_date');
let $dateTimePickerInput = $('#start_date_input');
window.$ = window.jQuery = require('jquery');
$(window).on('load', function () {
    // Defer images load
    let imgDefer = document.getElementsByTagName('img');
    for (let i = 0; i < imgDefer.length; i++) {
        if (imgDefer[i].getAttribute('data-src')) {
            imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('data-src'));
        }
    }
    // Animate loader off screen
    $(".se-pre-con").fadeOut("slow");
});

$('.error-alert').click(function () {
    $(this).hide();
});

$('.alert').click(function () {
    $(this).hide();
});

$('.btn-share-tourney').click(function () {
    event.stopPropagation();
    let link = this.dataset.href;
    let lang = this.dataset.lang;
    navigator.clipboard.writeText(link).then(() => {
        console.log('Clipboard successfully set to ' + link);
        if (lang === 'en')
            alert('Tourney URL was copied to your clipboard! Share it anywhere by pasting the link.');
        else
            alert('Turnyro nuoroda nukopijuota, pasidalinkite ja!');
    }, () => {
        console.log('Clipboard setting failed');
    });
});

$(".change-lang").click(function () {
    window.location.href = this.dataset.url + "?lang=" + this.dataset.lang;
})

if ($dateTimePicker.length > 0) {
    // new TempusDominus(document.getElementById('start_date'),{
    //     hooks: {
    //         inputFormat: 'YYYY-MM-DD HH:mm'
    //     }
    // });
    let dateFormat = 'YYYY-MM-DD HH:mm';
    let dateMin = moment().format(dateFormat);
    $dateTimePicker.datetimepicker({
        display: {
            format: dateFormat
        },
        format: dateFormat,
        icons: {
            time: "fa fa-clock",
            date: "fa fa-calendar",
            up: "fa fa-arrow-up",
            down: "fa fa-arrow-down"
        },
        date: $dateTimePickerInput.val() ?? dateMin,
        // minDate: dateMin,
    });
    $dateTimePicker.children().click(function () {
        $dateTimePicker.datetimepicker('show');
    });
}


if ($birthDatePicker.length > 0) {
    let dateFormat = 'YYYY-MM-DD';
    $birthDatePicker.datetimepicker({
        display: {
            format: dateFormat
        },
        format: dateFormat,
        icons: {
            time: "fa fa-clock",
            date: "fa fa-calendar",
            up: "fa fa-arrow-up",
            down: "fa fa-arrow-down"
        }
    });
    $birthDatePicker.children().click(function () {
        $birthDatePicker.datetimepicker('show');
    });
}
// $('#start_date').on('change.datetimepicker', function(e) {
//     if (e.oldDate !== null){
//         $this.data('datetimepicker').date();
//     }
//     return false;
// });
let $reorderForm = $('#reorderPlayerPlacementForm')

if ($reorderForm.length > 0) {
    let inputs = $.map($('ol li'), function (e, i) {
        return '<input name="players[]" data-hidden="order" type="hidden" value="' + $(e).data('value') + '"/>';
    });
    $('#orderContainer').append(inputs.join(" "));
}

$('.btn-view-tourney').on('click', function (e) {
    $("#tourneyInfoModalBody").fadeOut("fast");
});

$('#tourneyInfoModal').on('shown.bs.modal', function (e) {
    // $("#tourneyInfoModalBody").fadeOut("fast");
    $("#modalSpinner").fadeIn("slow");
    // let slug = $(e.relatedTarget).attr('data-slug');
    let lang = $(e.relatedTarget).attr('data-lang');
    let id = $(e.relatedTarget).attr('data-identifier');
    fetch(window.location.protocol + '//' + window.location.hostname + '/tourneys/' + id + '/info')
        .then(response => response.json())
        .then(data => {
            let name = data['name'];
            let coefficient = data['coefficient'];
            let description = data['description'];
            let levels = data['levels'];
            if (lang === 'en' && data['name_en'].length > 0 && data['description_en'].length > 0 && data['levels_en'].length > 0) {
                name = data['name_en'];
                description = data['description_en'];
                levels = data['levels_en'];
            }
            let startDate = data['start_date'];
            let playerCount = data['player_count'];
            let buyInPrice = data['buyin_price'];
            let addonPrice = data['addon_price'];
            let rebuyPrice = data['rebuy_price'];
            let initialTokenCount = data['initial_token_count'];
            let rebuyTokenCount = data['rebuy_token_count'];
            let addonTokenCount = data['addon_token_count'];
            let rebuyEndsAt = data['rebuy_until_turn'];
            let addonStartAt = data['addon_after_turn'];
            let lateRegistration = data['late_reg'];
            $('#tourneyNameField').text(name);
            $('#tourneyInfoModalLabel').text(name);
            $('#tourneyPlayersCountField').text(playerCount);
            $('#tourneyCoefficientField').text(coefficient);
            $('#tourneyDescriptionField').text(description);
            $('#tourneyLevelsDescriptionField').text(levels);
            $('#tourneyStartDateField').text(startDate);
            $('#tourneyLateRegField').text(lateRegistration);
            $('#buyinPriceField').text(buyInPrice);
            $('#initialTokenCountField').text(initialTokenCount);
            $('#rebuyPriceField').text(rebuyPrice);
            $('#rebuyTokenCountField').text(rebuyTokenCount);
            $('#rebuyUntilField').text(rebuyEndsAt);
            $('#addonPriceField').text(addonPrice);
            $('#addonTokenCountField').text(addonTokenCount);
            $('#addonAfterField').text(addonStartAt);
            $('#modalRegisterLink').attr('href', window.location.protocol + '//' + window.location.hostname + '/tourneys/' + id + '/status');
            $("#modalSpinner").fadeOut("fast");
            $("#tourneyInfoModalBody").fadeIn("slow");
        });
})

let $selectPickerPlayer = $('#player_id');

$selectPickerPlayer.selectpicker('refresh');


$(".month-chooser").on("changed.bs.select",
    function (e, clickedIndex, newValue, oldValue) {
        let getUrl = window.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host;
        window.location.href = baseUrl + '/points/monthly?filter=' + this.value;
    });


$('#playerSelection .bs-searchbox .form-control').on('keyup', function () {
    let query = this.value;
    let lang = $('#lang').val();
    if (query.length < 3 && lang === 'en') {
        $('#info').text('Input at least three symbols...');
        $selectPickerPlayer.selectpicker('refresh');
    }
    if (query.length < 3 && lang === 'lt') {
        $('#info').text('Įrašykite bent tris simbolius...');
        $selectPickerPlayer.selectpicker('refresh');
    }
    if (query.length >= 3) {
        let choosingMessage = "Choose Players...";
        let tourney_id = $('#tourney').val();
        let multiple = $('#multiple').val();
        let uriQuery = encodeURIComponent(query);
        uriQuery = uriQuery.replace(" ", "+");
        let link = window.location.protocol + '//' + window.location.hostname + '/tourneys/' + tourney_id + '/users/' + uriQuery;
        fetch(link)
            .then(response => response.json())
            .then(function (data) {
                if (multiple === '0' && lang === 'lt')
                    choosingMessage = 'Pasirinkite Žaidėją...';
                if (multiple === '1' && lang === 'lt')
                    choosingMessage = 'Pasirinkite Žaidėjus...';
                if (multiple === '0' && lang === 'en')
                    choosingMessage = 'Choose a Player...';
                if (multiple === '1' && lang === 'en')
                    choosingMessage = 'Choose Players...';
                $('#info').text(choosingMessage);
                $('option', $selectPickerPlayer).not(':eq(0), :selected').remove();
                data.forEach(function (item) {
                    $("#player_id").append('<option value=' + item.id + '>' + item.name + ' ' + item.surname + '</option>');
                })
                $selectPickerPlayer.selectpicker('refresh');
            });
    }
});


$(document).ready(function () {
    const pdfOpenParams = "#page=1&pagemode=none"; //pagemode=none,bookmarks,thumbs
    //Fancybox settings
    $(".fancybox-pdf").fancybox({
        type: 'iframe',
        padding: 0,
        openEffect: 'fade',
        openSpeed: 150,
        closeEffect: 'fade',
        closeSpeed: 150,
        closeClick: true,
        width: '60%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        iframe: {
            preload: false
        },
        //Define PDF.js viewer with optional parameters
        beforeLoad: function () {
            const url = $(this.element).attr("href");
            this.href = "./includes/js/pdfjs/web/viewer.html?file=" + url + pdfOpenParams;
        }
    });
});


let $selectPickerUser = $('#user_id');

$selectPickerUser.selectpicker('refresh');
$('#userSelection .bs-searchbox .form-control').on('keyup', function () {
    let query = this.value;
    let lang = $('#lang').val();
    if (query.length < 3 && lang === 'en') {
        $('#info').text('Input at least three symbols...');
        $selectPickerUser.selectpicker('refresh');
    }
    if (query.length < 3 && lang === 'lt') {
        $('#info').text('Įrašykite bent tris simbolius...');
        $selectPickerUser.selectpicker('refresh');
    }
    if (query.length >= 3) {
        let uriQuery = encodeURIComponent(query);
        uriQuery = uriQuery.replace(" ", "+");
        let link =  window.location.protocol + '//' + window.location.hostname + '/users-json/' + uriQuery;
        fetch(link)
            .then(response => response.json())
            .then(function (data) {
                if (lang === 'lt')
                    $('#info').text('Pasirinkite Vartotojus...');
                else
                    $('#info').text('Choose Users...');
                $('option', $selectPickerUser).not(':eq(0), :selected').remove();
                data.forEach(function (item) {
                    $("#user_id").append('<option value=' + item.id + '>' + item.name + ' ' + item.surname + '</option>');
                })
                $selectPickerUser.selectpicker('refresh');
            });
    }
});
